<template>
<div>
  <v-container>
    <v-row>
      <v-col>
          <Packagedata/>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import Packagedata from '../../components/Admin/Package-data'

export default{
  components:{
    Packagedata
  }
}
</script>


